import axios from 'axios';

const get = () => axios.get('/transportadoras');
const getBy = (id) => axios.get(`/transportadoras/${id}`);
const update = (id, data) => axios.put(`/transportadoras/${id}`, data);

export default {
  get,
  getBy,
  update,
};
